<template>
  <main class="main-page">
    <Dialog
    class="card p-0" modal 
      header="Recipients List"
      v-model:visible="dialogs.showRecipientsList"
      :style="{ width: '50vw' }"
    >
    <api-data-source :api-path="`components_data/recipients_list/${dialogs.messageChannel}/${dialogs.messageId}`" v-slot="record">
      <div
        v-if="!record.loading"
      >
        <div v-for="(item, index) in record.response" :key="index" >
          <div class="card"> 
            <Chip class="font-medium px-2 py-1 mx-1 mb-3">To: {{  item.recipient }}</Chip>
            <div>{{  item.message }}</div>
          </div>
        </div>
      </div>
      <div v-else>
          <div class="my-3" v-for="n in 5" :key="n">
            <Skeleton class="py-3" borderRadius="16px" />
          </div>
      </div>
    </api-data-source>
    </Dialog>
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid card pt-2 pb-3 justify-content-between">
          <div class="col">
            <div class="">
              <div class="text-3xl font-bold mt-2">Messages</div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <div class="">
              <template v-if="$auth.canView('/feeds/add')">
                <Button
                  label="Send Out Message"
                  icon="pi pi-envelope"
                  @click="
                    app.openPageDialog({
                      page: 'feeds/add',
                      url: `/feeds/add`,
                      persistent: true,
                      closeBtn: true,
                      position: 'center',
                    })
                  "
                  class="w-full bg-primary p-button-rounded"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section">
      <TabView :selectOnFocus="true" :scrollable="false" v-model:activeIndex="filters.channel.value">
        <TabPanel>
          <template #header>
            <span>Mobile App</span>
          </template>
        </TabPanel>
        <TabPanel>
          <template #header>
            <span>SMS</span>
          </template>
        </TabPanel>
        <TabPanel>
          <template #header>
            <span>Email </span>
          </template>
        </TabPanel>
      </TabView>
    </section>
    <section class="page-section">
        <div class="container-fluid">
          <div class="grid">
            <div class="col comp-grid">
              <div class="flex align-items-center justify-content-around">
                <div v-if="searchText" :class="filterTagClass">
                  <Breadcrumb
                    :home="{
                      icon: 'pi pi-times text-lg mr-3',
                      label: 'Search',
                    }"
                    :model="[
                      {
                        label: `${searchText}`,
                      },
                    ]"
                  >
                    <template #item="{ item }">
                      <div
                        class="cursor-pointer"
                        :class="item.icon"
                        @click="
                          () => {
                            clearSearch();
                          }
                        "
                      ></div>
                      <a :href="item.url">{{ item.label }}</a>
                    </template>
                  </Breadcrumb>
                </div>
              </div>
              <div>
                <template v-if="showBreadcrumbs && $route.query.tag">
                  <Breadcrumb
                    :home="{ icon: 'pi pi-home', to: '/feeds' }"
                    :model="pageBreadCrumb"
                  />
                </template>
                <!-- page records template -->
                <div class="page-records" v-if="!loading">
                  <DataTable
                    :lazy="true"
                    :loading="loading"
                    v-model:selection="selectedItems"
                    :value="records"
                    dataKey="feed_id"
                    @sort="onSort($event)"
                    class=""
                    :showGridlines="false"
                    :rowHover="true"
                    responsiveLayout="stack"
                  >
                    <Column
                      selectionMode="multiple"
                      headerStyle="width: 3em"
                    ></Column>
                    <Column v-if="filters.channel.value == 0" field="feed_type" header="Category">
                      <template #body="{ data }">
                        {{ $utils.capitalize(data.feed_type) }}
                      </template>
                    </Column>
                    <Column v-if="filters.channel.value == 0" field="title" header="Title">
                      <template #body="{ data }">
                        {{ data.title }}
                      </template>
                    </Column>
                    <Column field="message" header="Message">
                      <template #body="{ data }">
                        <div v-if="filters.channel.value == 0">{{ $utils.truncate(data.message, 50) }}</div>
                        <div v-else>{{  $utils.truncate(data.message, 200) }} </div>
                      </template>
                    </Column>
                    <Column v-if="filters.channel.value != 0" field="audience" headerStyle="width: 12em" header="Audience">
                      <template #body="{ data }">
                        <Button type="button" class="p-button-sm p-button-primary p-button-link p-0" @click="showList(data)">{{  data.audience }} recipients</Button>
                        <!-- <span v-for="(item, index) in JSON.parse(data.audience).length" :key="index" class="font-medium">{{ index += index }} • </span> -->
                      </template>
                    </Column>
                    <Column v-if="filters.channel.value == 0" field="media" header="Media">
                      <template #body="{ data }">
                        <image-viewer
                          image-size="medium"
                          image-preview-size=""
                          :src="data.media"
                          width="30px"
                          height="30px"
                          :num-display="10"
                        >
                        </image-viewer>
                      </template>
                    </Column>
                    <Column field="date_created" header="Date Sent">
                      <template #body="{ data }">
                        {{ $utils.humanDatetime(data.date_created) }}
                      </template>
                    </Column>
                    <Column v-if="filters.channel.value == 0" field="reactions" header="Impressions">
                      <template #body="{ data }">
                        {{ data.reactions }}
                      </template>
                    </Column>
                    <Column v-if="filters.channel.value == 0" headerStyle="width: 3em" headerClass="text-center">
                      <template #body="{ data }">
                        <SplitButton
                          class="p-button p-button-raised p-button-text p-button-sm"
                          :model="getActionMenuModel(data)"
                        >
                          <i></i>
                        </SplitButton>
                      </template>
                    </Column>
                  </DataTable>
                </div>
                <!-- page loading indicator -->
                <template v-if="loading">
                  <div>
                    <DataTable :value="[1, 2, 3, 4, 5]" responsiveLayout="scroll">
                      <Column style="width: 3rem">
                        <template #body>
                          <Skeleton shape="circle" size="2rem" />
                        </template>
                      </Column>
                      <Column>
                        <template #body>
                          <Skeleton />
                        </template>
                      </Column>
                      <Column>
                        <template #body>
                          <Skeleton borderRadius="16px" />
                        </template>
                      </Column>
                      <Column>
                        <template #body>
                          <Skeleton />
                        </template>
                      </Column>
                      <Column style="width: 3rem">
                        <template #body>
                          <Skeleton size="2rem" />
                        </template>
                      </Column>
                    </DataTable>
                  </div>
                </template>
                <!-- end of page loading indicator-->
                <!-- Empty record -->
                <template v-if="pageReady && !records.length">
                  <div class="p-3 my-3 text-500 text-lg font-medium text-center">
                    No messages found
                  </div>
                </template>
                <!-- end of empty record-->
                <!-- pagination component-->
                <template v-if="showFooter">
                  <div class="">
                    <div v-show="pageReady">
                      <div class="flex justify-content-between">
                        <div class="flex justify-content-center flex-grow-0">
                          <div v-if="selectedItems.length" class="m-2">
                            <Button
                              @click="deleteItem(selectedItems)"
                              icon="pi pi-trash"
                              class="p-button-danger"
                              title="Delete Selected"
                            />
                          </div>
                        </div>
                        <div
                          v-if="paginate && totalPages > 1"
                          class="flex-grow-1"
                        >
                          <Paginator
                            class="border-none bg-transparent py-3"
                            :first="recordsPosition"
                            @page="
                              (event) => {
                                pagination.page = event.page + 1;
                              }
                            "
                            :rows="pagination.limit"
                            :totalRecords="totalRecords"
                          >
                            <template #start>
                              <span class="text-sm text-gray-500 px-2">
                                Records
                                <b>{{ recordsPosition }} of {{ totalRecords }}</b>
                              </span>
                            </template>
                            <template #end> </template>
                          </Paginator>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- end of pagination component-->
              </div>
            </div>
          </div>
        </div>
      </section>
  </main>
</template>
<script setup>
import { reactive, toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useListPage } from "@/composables/listpage.js";
const props = defineProps({
  primaryKey: {
    type: String,
    default: "feed_id",
  },
  pageName: {
    type: String,
    default: "feeds",
  },
  routeName: {
    type: String,
    default: "feedslist",
  },
  apiPath: {
    type: String,
    default: "feeds/index",
  },
  paginate: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showBreadcrumbs: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  importButton: {
    type: Boolean,
    default: false,
  },
  multiCheckbox: {
    type: Boolean,
    default: true,
  },
  emptyRecordMsg: {
    type: String,
    default: "No record found",
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 10,
  },
  mergeRecords: {
    // for infinite loading
    type: Boolean,
    default: false,
  },
  search: {
    type: String,
    default: "",
  },
  fieldName: null,
  fieldValue: null,
  sortBy: {
    type: String,
    default: "",
  },
  sortType: {
    type: String,
    default: "", //desc or asc
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  filterTagClass: {
    type: String,
    default:
      "surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-center",
  },
});
const app = useApp();
const auth = useAuth();
const dialogs = reactive({
  showRecipientsList: false,
  messageId: 0,
  messageChannel: ""
});
const filters = reactive({
  channel: {
    value: 0,
    valueType: "single",
    options: [],
  },
});
// init list page hook
const page = useListPage(props, filters);
const { state, methodsProps } = page;
const {
  totalRecords,
  recordCount,
  loading,
  selectedItems,
  pagination,
  searchText,
  pageReady,
} = toRefs(page.state);
const {
  records,
  apiUrl,
  currentRecord,
  pageBreadCrumb,
  canLoadMore,
  finishedLoading,
  totalPages,
  recordsPosition,
} = page.computedProps;
const {
  load,
  reload,
  loadNextPage,
  loadPreviousPage,
  exportPage,
  clearSearch,
  onSort,
  deleteItem,
  setCurrentRecord,
  isCurrentRecord,
  removeFilter,
  getFilterLabel,
  filterHasValue,
  importComplete,
} = page.methods;

function getActionMenuModel(data) {
  return [
    {
      label: "View More",
      command: (event) => {
        app.openPageDialog({
          page: "feeds/view",
          url: `/feeds/view/${data.feed_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
        });
      },
      icon: "pi pi-eye",
      visible: auth.canView("feeds/view"),
    },
    {
      label: "Edit",
      command: (event) => {
        app.openPageDialog({
          page: "feeds/edit",
          url: `/feeds/edit/${data.feed_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
        });
      },
      icon: "pi pi-pencil",
      visible: auth.canView("feeds/edit"),
    },
    {
      label: "Delete",
      command: (event) => {
        deleteItem(data.feed_id);
      },
      icon: "pi pi-minus-circle",
      visible: auth.canView("feeds/delete"),
    },
  ];
}

function showList(data) {
  if(data){
    Object.assign(dialogs, {showRecipientsList: true, messageId: data.feed_id, messageChannel: data.channel })
  }
}
onMounted(() => {
  const pageTitle = "Messages";
  app.setPageTitle(props.routeName, pageTitle);
  load();
});
</script>
<style scoped></style>